import { render } from "./Breadcrumbs.vue?vue&type=template&id=5147ac24&scoped=true"
import script from "./Breadcrumbs.vue?vue&type=script&lang=js"
export * from "./Breadcrumbs.vue?vue&type=script&lang=js"

import "./Breadcrumbs.vue?vue&type=style&index=0&id=5147ac24&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5147ac24"],['__file',"webpack-assets/vue/components/Breadcrumbs.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5147ac24"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5147ac24', __exports__)) {
    api.reload('5147ac24', __exports__)
  }
  
  module.hot.accept("./Breadcrumbs.vue?vue&type=template&id=5147ac24&scoped=true", () => {
    api.rerender('5147ac24', render)
  })

}


export default __exports__